<!-- Caja completa de comentarios Post: nuevo diseño tipo tarjeta. Lógica intacta (post, comments, addComment, deletePost, checkCanDelete). -->
<div class="rounded-xl border border-[#E8EAEF]  p-3 relative">

    <!-- Cabecera: avatar a la izquierda, nombre/fecha y contenido apilados a la derecha -->
    <div class="flex items-start gap-3 mb-3">
        <img class="w-8 h-8 rounded-full object-cover flex-shrink-0" [src]="post?.account?.picture+'?size=48'" *ngIf="post?.account?.picture">
        <div class="w-8 h-8 rounded-full bg-[#FFD9DF] text-[#E21D48] flex items-center justify-center text-sm font-semibold flex-shrink-0" *ngIf="post?.account && !post?.account?.picture">
            {{ post?.account?.name?.charAt(0) }}
        </div>

        <div class="flex flex-col min-w-0">
            <div class="flex items-center gap-2">
                <span class="text-sm font-normal text-gray-700" *ngIf="post?.account">{{ post.account.name }}</span>
                <span class="text-xs text-gray-400 font-normal">{{ getDate(post.createdAt) }}</span>
            </div>

            <!-- Contenido del post: alto natural según el texto -->
            <div class="mt-1">
                <timeline-show-content [content]="post?.content" [media]="post?.media"></timeline-show-content>
                <msc-link-manager [content]="post?.content?.message"></msc-link-manager>
            </div>
        </div>
    </div>

    <!-- Sección de respuestas: el form de "Respuesta" solo se muestra al hacer click en Responder -->
    <div>
        <button type="button" class="px-6 mx-4 inline-flex items-center gap-1.5 text-xs text-gray-600 hover:text-[#22304C] mb-3" (click)="showReplyForm = !showReplyForm">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-corner-up-left w-3.5 h-3.5"><polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path></svg> {{ 'words.reply' | translate }}
        </button>

        <ng-container *ngIf="post?.comments?.length">
            <div class="pl-4 px-6 mx-4 border-l-2 border-[#E21D48]/50 space-y-3 mb-3">
                <div class="comment" *ngFor="let comment of post.comments">
                    <msc-comment [me]="me" [companyOwner]="companyOwner" [comment]="comment" (onDelete)="deleteComment($event)"></msc-comment>
                </div>
            </div>
        </ng-container>

        <form class="new-post " #postForm *ngIf="showReplyForm">
            <timeline-add-content (addContent)="addComment($event, post?.id, postForm)" [placeholder]="('player.timeline.placeholder.answer' | translate)" [avatar]="me?.picture" [avatarInitial]="me?.name?.charAt(0)"></timeline-add-content>
        </form>
    </div>

    <timeline-delete-content *ngIf="checkCanDelete()" [message]="'words.delete-confirm-comment'" (deleteContent)="onDeletePost()"></timeline-delete-content>
</div>
